<template>
  <div>
    search
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// search.vue?2596f214